export const defaultWindowMeasurements: [number, number] = [2, 1.20] //2.4 area
export const defaultDoorMeasurements: [number, number] = [0.80, 1.90] // 1.52 area